/**
 * TakomoModal — Shopify theme integration
 *
 * Intercepts Shopify's native modal-opener triggers and opens
 * their content in TakomoModal instead of the built-in popup.
 *
 * Load AFTER takomo-modal.js in theme.liquid:
 *   {{ 'takomo-modal.css' | asset_url | stylesheet_tag }}
 *   {{ 'takomo-modal.js' | asset_url | script_tag }}
 *   {{ 'takomo-modal-shopify.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal]');
    if (!opener) return;

    var selector = opener.getAttribute('data-modal');
    if (!selector) return;

    var modal = document.querySelector(selector);
    if (!modal) return;

    // Skip gallery zoom — let native product-modal handle it
    if (modal.tagName && modal.tagName.toLowerCase() === 'product-modal') return;

    // Stop Shopify's native handler from opening
    e.preventDefault();
    e.stopPropagation();

    // Extract content from the hidden popup element.
    // Try known Dawn/Shopify content wrappers, fall back to full inner HTML.
    var source = modal.querySelector('.modal__content-info')
      || modal.querySelector('.modal__content')
      || modal.querySelector('.page-width')
      || modal;

    TakomoModal.open({
      content: source.innerHTML,
      theme: 'light',
      closeButton: true,
      closeLabel: opener.getAttribute('data-modal-close-label') || 'Close'
    });
  }, true);
})();
